/**
 * Youtube utilities
 *
 * Methods of this object allow you to parse a youtube id from a url along with
 * making a JSONP call to youtube's API to retrieve details about a video
 *
 * @author MattJS (matt@yext.com)
 */
goog.module('yext.youtube');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');


var YOUTUBE_URL_REGEX = [
  /(?:youtube.com\/watch\?(?:|.+&)v=)([^&\/\?]{11,})/,
  /(?:youtube.com\/v\/)([^&\/\?]{11,})/,
  /(?:youtube.com\/embed\/)([^&\/\?]{11,})/,
  /(?:youtu.be\/)([^&\/\?]{11,})/,
];

var DURATION_REGEX = /PT(([0-9]*\.?[0-9]*)H)?(([0-9]*\.?[0-9]*)M)?(([0-9]*\.?[0-9]*)S)?/;

/**
 * Parses the youtube id from a url string
 *
 * @param {string} youtubeUrl A url string for a youtube video
 * @return {string} youtubeId A alphanumeric string that identifies a video
 */
function parseIdFromUrl(youtubeUrl) {
  var match;

  for (var i = 0; i < YOUTUBE_URL_REGEX.length; i++) {
    match = YOUTUBE_URL_REGEX[i].exec(youtubeUrl);
    if (match != null) {
      break;
    }
  }

  return match ? match[1] : '';
}

/**
 * Checks to see if a youtube url is valid
 *
 * @param {string} youtubeUrl A url string for a youtube video
 * @return {boolean} If the youtube url is valid
 */
function validUrl(youtubeUrl) {
  var valid = false;

  for (var i = 0; i < YOUTUBE_URL_REGEX.length; i++) {
    if (YOUTUBE_URL_REGEX[i].test(youtubeUrl)) {
      valid = true;
      break;
    }
  }

  return valid;
}

/**
 * Get video details from a youtube id and trigger callbacks on success or failure
 *
 * @param {!Array.<string>} youtubeIds A  list of alphanumeric strings that identifies a video
 * @param {function()} success A callback for when the request is successful
 * @param {function()} error A callback for when the request causes an error
 */
function getVideosDetails(youtubeIds, success, error) {
  error = error || function() {};
  $.ajax({
    url: 'https://www.googleapis.com/youtube/v3/videos' +
      '?key=AIzaSyDPbj7wOaE0F3ZhSMYtQjo-dW0sCG67YpU' +
      '&part=snippet,contentDetails&id=' + encodeURIComponent(youtubeIds.join(',')),
    dataType: 'jsonp',
    timeout: 10000,
    success: function(data) {
      if (data && data.items) {
        var videos = [];
        if (data.items.length) {
          $.each(data.items, function(i, item) {
            var snippet = item.snippet;
            var video = new Video(item.id);
            video.title = snippet.title;
            video.thumbnail = snippet.thumbnails['default']['url'];
            video.duration = generateDurationString(item.contentDetails.duration);
            video.url = getYouTubeUrl(item.id);
            videos.push(video);
          });
        }

        if (yext.isFunction(success)) {
          success(videos);
        }
      } else {
        if (yext.isFunction(error)) {
          error();
        }
      }
    },
    error: error,
  });
}

var generateDurationString = function(duration) {
  if (duration === 'P0D') return '';
  var matches = duration.match(DURATION_REGEX);
  var hours = matches[2];
  hours = hours && hours < 10 ? '0' + hours : hours;
  var minutes = matches[4];
  minutes = !minutes ? '0' : minutes;
  minutes = minutes && minutes < 10 ? '0' + minutes : minutes;
  var seconds = matches[6];
  seconds = !seconds ? '0' : seconds;
  seconds = seconds && seconds < 10 ? '0' + seconds : seconds;
  var result = '';
  result += hours ? hours + ':' : '';
  result += minutes ? minutes + ':' : '';
  result += seconds ? seconds : '00';
  return result;
};


/**
 * @param {string} videoId video id
 * @return {string} the youtube url
 */
var getYouTubeUrl = function(videoId) {
  return 'http://www.youtube.com/watch?v=' + videoId;
};

/** @constructor */
var Video = function(id) {
  this.id = id;
  this.duration = '';
  this.thumbnail = undefined;
  // TODO (mkintali): Check if the v3 API has this field anywhere
  this.uploader = 'unknown';
  this.url = getYouTubeUrl(id);
};

/**
 * @param {string} videoId video id
 * @return {string} the thumbnail Url for a youtube id
 */
function getYoutubeThumbnailUrl(videoId) {
  return 'https://img.youtube.com/vi/'+ videoId +'/default.jpg';
}


exports = {
  parseIdFromUrl,
  validUrl,
  getVideosDetails,
  getYoutubeThumbnailUrl,
};
